export default __webpack_public_path__ + "static/title_center-9f80324e122bfa72811180b4ef9059e1.png";